import { styled } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

export const StyledRow = styled.button`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    width: 100%;
    border: 0;
    background: transparent;
    text-align: left;
    cursor: pointer;
    padding: 10px 16px;

    &:hover {
        background-color: ${colorsPalettes.carbon["50"]};
    }

    &:focus-visible {
        outline: 2px solid ${colorsPalettes.midnight[300]};
        outline-offset: -2px;
    }

    &:disabled {
        cursor: not-allowed;
    }

    &:disabled:hover {
        background-color: transparent;
    }
`;
